module.exports = __webpack_public_path__ + "img/boy-avatar.5ff53af9.png";